let authToken: string | null = null;

export const getHasJWT = (): boolean => !!authToken;
export const getJWT = (): string | null => authToken;
export const setJWT = (newAuthToken: string): void => {
  authToken = newAuthToken || null;
};

export const getHasRefreshToken = (): boolean => false;
export const getRefreshToken = (): string | null => null;
export const setRefreshToken = (_refreshToken: string): void => {
  void _refreshToken;
};
